import * as actionNameTypes from "./actionType";

export const myAccountDataSuccess = payload => ({
  type: "MY_ACCOUNT_DATA_SUCCESS",
  payload
});

export const designatedDataSuccess = payload => ({
  type: actionNameTypes.designatedData,
  payload
});
export const fetchMyAccountData = payload => ({
  type: actionNameTypes.fetchMyAccDataType,
  payload
});

export const fetchMyAccountMapping = payload => ({
  type: actionNameTypes.fetchMyAccMappingType,
  payload
});

export const resetDesignatedDataSuccess = payload => ({
  type: actionNameTypes.resetDesignatedDataType,
  payload
});

export const showComponent = payload => ({
  type: actionNameTypes.showComponentType,
  payload
});
export const hideComponent = payload => ({
  type: actionNameTypes.hideComponentType,
  payload
});

export const myProfileDataSuccess = payload => ({
  type: actionNameTypes.myProfileDataSuccessType,
  payload
});
export const myProfileDataSuccessNeedAssistance = payload => ({
  type: "MY_PROFILE_DATA_SUCCESS_NEEDASSISTANCE",
  payload
});

export const tableDataSuccess = payload => ({
  type: actionNameTypes.tableDataSuccessType,
  payload
});

export const changeName = payload => ({
  type: actionNameTypes.changeNameType,
  payload
});

export const newFundName = payload => ({
  type: actionNameTypes.saveNewFundNameType,
  payload
});

export const hide504Error = () => ({
  type: actionNameTypes.hide504Error
});

export const newFundNameForSave = payload => ({
  type: actionNameTypes.newFundNameToSaveType,
  payload
});

export const changePrimary = payload => ({
  type: actionNameTypes.changePrimaryType,
  payload
});

export const savePrimaryAccount = payload => ({
  type: actionNameTypes.savePrimaryAccountType,
  payload
});

export const addDesignated = payload => ({
  type: actionNameTypes.addDesignatedType,
  payload
});

export const clearEditProfileError = payload => ({
  type: actionNameTypes.clearEditProfileErrorType,
  payload
});

/********************************************** ACTIONS FOR EDIT PROFILE *********************************************/
export const postProfile = payload => ({
  type: actionNameTypes.postProfileType,
  payload
});
export const profileJsonTemp = payload => ({
  type: actionNameTypes.profileJsonTempType,
  payload
});
/********************************************** ACTIONS FOR ADVISOR & SUCCESSION *********************************************/
export const prefillValuesPrimary = payload => ({
  type: actionNameTypes.prefilPrimaryValType,
  payload
});

export const prefillValuesSecondary = payload => ({
  type: actionNameTypes.prefilSecValuesType,
  payload
});

export const onEmailChangeHandler = payload => ({
  type: actionNameTypes.emailChangeHandlerType,
  payload
});

export const prefillValuesPhonePrimary = payload => ({
  type: actionNameTypes.prefilPrimaryPhoneValType,
  payload
});

export const prefillValuesPhoneSecondary = payload => ({
  type: actionNameTypes.prefilSecondaryPhoneValType,
  payload
});

export const onPhoneChangeHandler = payload => ({
  type: actionNameTypes.changePhoneHandlerType,
  payload
});

export const prefillValuesAddressPrimary = payload => ({
  type: actionNameTypes.prefilPrimaryAddrValType,
  payload
});

export const prefillValuesAddressSecondary = payload => ({
  type: actionNameTypes.prefilSecAddrValType,
  payload
});

export const onAddressChangeHandler = payload => ({
  type: actionNameTypes.changeAddressHandlerType,
  payload
});

export const handleResetFormAddress = payload => ({
  type: actionNameTypes.resetFormAddrType,
  payload
});

export const handleResetFormPhone = payload => ({
  type: actionNameTypes.resetFormPhoneType,
  payload
});

export const handleResetFormEmail = payload => ({
  type: actionNameTypes.resetFormEmailType,
  payload
});

export const handleResetSecFormBasicInfo = payload => ({
  type: actionNameTypes.clearSecAdvFormType,
  payload
});

export const prefillValuesInfoPrimary = payload => ({
  type: actionNameTypes.prefilPrimaryValType,
  payload
});

export const prefillValuesInfoSecondary = payload => ({
  type: actionNameTypes.prefilSecondaryValType,
  payload
});

export const handleInfoChange = payload => ({
  type: actionNameTypes.handleInfoChangeType,
  payload
});

export const handleResetFormInfo = payload => ({
  type: actionNameTypes.resetFormType,
  payload
});

export const handleResetFormRelatedContributor = payload => ({
  type: actionNameTypes.resetFormContributorType,
  payload
});

export const getProfileData = payload => ({
  type: "GET_PROFILE_DATA",
  payload
});
export const handleRadioChangePrimary = payload => ({
  type: actionNameTypes.handleRadioChangePrimaryType,
  payload
});

export const handleRadioChangeSecondary = payload => ({
  type: actionNameTypes.handleRadioChangeSecondaryType,
  payload
});

export const reset = payload => ({
  type: actionNameTypes.resetType,
  payload
});

export const disableButton = payload => ({
  type: actionNameTypes.addAdvBtnDisableType,
  payload
});

export const savePrimaryInfo = payload => ({
  type: actionNameTypes.savePrimaryInfoType,
  payload
});

export const getZipCode = payload => ({
  type: actionNameTypes.fetchZipCode,
  payload
});

export const relatedContributorInfo = payload => ({
  type: "GET_RC_DATA",
  payload
});

export const relatedContributorPrimary = payload => ({
  type: actionNameTypes.relatedContributorPrimaryType,
  payload
});

export const relatedContributorSecondary = payload => ({
  type: actionNameTypes.relatedContributorSecondaryType,
  payload
});

export const addSuccessorCount = payload => ({
  type: "INCREMENT_DECREMENT_COUNT",
  payload
});

export const handleInputChange = payload => ({
  type: "INPUT_CHANGE",
  payload
});

export const handleError = payload => ({
  type: "HANDLE_ERROR",
  payload
});

export const savePercentage = payload => ({
  type: actionNameTypes.savePercentageType,
  payload
});

export const setLegacyValues = payload => ({
  type: "SET_LEGACY_VALUES",
  payload
});

export const saveSuccessorValues = payload => ({
  type: actionNameTypes.saveSuccessorValuesType,
  payload
});

export const addSuccessor = payload => ({
  type: actionNameTypes.addSuccessorType,
  payload
});

export const updateActivePageStepName = payload => ({
  type: actionNameTypes.updateStepNameType,
  payload
});

export const resetLegacy = payload => ({
  type: actionNameTypes.resetLegacyType,
  payload
});

export const showRemainingPercentage = payload => ({
  type: actionNameTypes.showRemainingPercentageType,
  payload
});

export const removeValues = payload => ({
  type: actionNameTypes.removeValuesType,
  payload
});

export const showMainPercentage = payload => ({
  type: "SHOW_MAIN_PERCENTAGE",
  payload
});

export const shouldClose = payload => ({
  type: actionNameTypes.shouldCloseType,
  payload
});

export const isSecondaryAdvisor = payload => ({
  type: actionNameTypes.isSecAdvType,
  payload
});

export const shouldShowMore = payload => ({
  type: "SHOULD_SHOW_MORE",
  payload
});

export const step1Edit = payload => ({
  type: actionNameTypes.step1EditType,
  payload
});

export const step2Edit = payload => ({
  type: "STEP2_EDIT",
  payload
});

export const jsonfinal = payload => ({
  type: "STORE_FINAL_JSON",
  payload
});

export const jsonTemp = payload => ({
  type: actionNameTypes.jsonTempType,
  payload
});

export const validateSubmit = payload => ({
  type: "VALIDATE_SUBMIT",
  payload
});

export const estInitialContr = payload => ({
  type: "EST_INIT_CONTRIBUTION",
  payload
});

export const emptyZip = payload => ({
  type: actionNameTypes.emptyZipType,
  payload
});

export const fetchSuccessionValues = payload => ({
  type: actionNameTypes.displaySuccessionValType,
  payload
});

export const fetchDropdownValues = payload => ({
  type: actionNameTypes.fetchDropDownValType,
  payload
});

export const legacyValuesFromApi = payload => ({
  type: actionNameTypes.legacyValuesFromApiType,
  payload
});


export const postAccountAdvisor = payload => ({
  type: actionNameTypes.postAccountAdvType,
  payload
});

export const addSecondaryAdvisor = payload => ({
  type: actionNameTypes.addSecondaryAdvisorType,
  payload
});

export const clearSecondaryAdvRes = payload => ({
  type: actionNameTypes.clearSecAdvType,
  payload
});

export const resetLegacyFromApi = payload => ({
  type: actionNameTypes.resetLegacyFromApiType,
  payload
});

export const updateSuccession = payload => ({
  type: actionNameTypes.updateSuccessionType,
  payload
});

export const updateDropdownValues = payload => ({
  type: actionNameTypes.updateDropDownValType,
  payload
});

export const doesOthersExist = payload => ({
  type: actionNameTypes.doesOthersExistType,
  payload
});

export const grantOptionPdf = payload => ({
  type: actionNameTypes.grantOptionPdfType,
  payload
});

export const saveOptionData = payload => ({
  type: actionNameTypes.saveOptionDataType,
  payload
});
export const errorVariable = payload => ({
  type: actionNameTypes.errorVariableType,
  payload
})
export const generateAccessKey = payload => ({
  type: actionNameTypes.generateAccessKeyType,
  payload
});


/*************Update user id************************* */

export const UpdateNewUserId = payload => ({
  type: actionNameTypes.UpdateNewUserIdType,
  payload
});

export const clearChangeUserId = payload => ({
  type: actionNameTypes.clearChangeUserIdType,
  payload
});
export const clearErrMessage = () => ({
  type: actionNameTypes.clearErrMessageType,
});

/*************Update mfa Email************************* */

export const UpdateNewmfaEmail = payload => ({
  type: actionNameTypes.UpdateNewmfaEmailType,
  payload
});

export const clearChangemfaEmail = payload => ({
  type: actionNameTypes.clearChangemfaEmailType,
  payload
});
export const clearmfaEmailErrMessage = () => ({
  type: actionNameTypes.clearmfaEmailErrMessageType,
});

/** Invite intertested parties actions */

export const postInvite = payload => ({
  type: actionNameTypes.postInviteType,
  payload
});

export const clearIipSubmit = payload => ({
  type: actionNameTypes.clearInvitePartyType,
  payload
});

export const clearIpIsError = payload => ({
  type: actionNameTypes.clearInvitePartyTypeError,
  payload
});

/** Invite intertested parties actions */

export const myAccountMandatoryMissing = payload => ({
  type: actionNameTypes.myAccMandatoryType,
  payload
});

export const updateLegacyFormValid = payload => ({
  type: actionNameTypes.udpateValidLegacyFormType,
  payload
});

/**********************Resend email for verification ******************************/

export const resendEmail = payload => ({
  type: actionNameTypes.resendEmailType,
  payload
});

export const resendEmailClearFlag = payload => ({
  type: actionNameTypes.resendEmailClearFlagType,
  payload
});

export const changeMFAPhNo = payload => ({
  type: actionNameTypes.changeMFAPhNoType,
  payload
});

export const changeMFAPhNoClearFlag = payload => ({
  type: actionNameTypes.changeMFAPhNoClearFlagType,
  payload
});

export const refreshMFAPhNoCom = payload => ({
  type: actionNameTypes.refreshMFAPhNoComType,
  payload
});

export const selectSuccessionPlan = payload => ({
  type: actionNameTypes.selectSuccessionPlanType,
  payload
});

export const showEspSubmitLoader = () => ({
	type: actionNameTypes.espSubmitLoader
});